<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-5 col-5">
          <h6 class="h2 d-inline-block mb-0">Record</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">Report</h3>
          </template>
          <div>
            <div class="col-xl-12">
              <div
                class="form-group row"
                v-if="isDtacAdmin || isReadOnly || isCorporateSuperAdminMenu"
              >
                <label for="report-enterprise" class="col-md-1 col-form-label form-control-label">{{
                  $t("report.enterprise")
                }}</label>
                <div class="col-md-2">
                  <base-input>
                    <el-select id="report-enterprise"
                      v-model="EnterpriseID"
                      filterable
                      :placeholder="$t('report.enterprise')"
                    >
                      <el-option label="All" value="0"></el-option>
                      <el-option
                        v-for="option in corporate"
                        :key="option.ID"
                        :label="option.Name"
                        :value="option.ID"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="report-type-select"
                  class="col-md-1 col-form-label form-control-label"
                  >{{ $t("report.type") }}</label
                >
                <div class="col-md-2">
                  <base-input>
                    <select
                      class="form-control"
                      id="report-type-select"
                      v-model="report_type"
                    >
                      <option value="1">{{ $t("report.cdr_report") }}</option>
                      <option value="2">{{
                        $t("report.dashboard_report")
                      }}</option>
                    </select>
                  </base-input>
                </div>

                <label
                  v-if="report_type == 2"
                  for="performanceReportTypeSelect"
                  class="col-md-1 col-form-label form-control-label"
                  >{{ $t("report.performance_report_type") }}</label
                >
                <div class="col-md-2" v-if="report_type == 2">
                  <base-input>
                    <select
                      class="form-control"
                      id="performanceReportTypeSelect"
                      v-model="performance_report_type"
                    >
                      <option value="1">{{
                        $t("report.performance_by_number")
                      }}</option>
                      <option value="2">{{
                        $t("report.performance_by_group")
                      }}</option>
                    </select>
                  </base-input>
                </div>

                <label
                  v-if="report_type == 1"
                  for="call_type"
                  class="col-md-1 col-form-label form-control-label"
                  >{{ $t("report.call_type") }}</label
                >
                <div class="col-md-2" v-if="report_type == 1">
                  <base-input>
                    <select
                      class="form-control"
                      id="call_type"
                      v-model="call_type"
                    >
                      <option value="0">{{ $t("report.all") }}</option>
                      <option value="1">{{ $t("report.inbound") }}</option>
                      <option value="2">{{ $t("report.outbound") }}</option>
                      <option value="3">{{ $t("report.internal") }}</option>
                      <option value="4">{{ $t("report.voicemail") }}</option>
                    </select>
                  </base-input>
                </div>
              </div>

              <div class="form-group row">
                <label for="report-number"
                  class="col-md-1 col-form-label form-control-label"
                  v-if="
                    report_type == 1 ||
                      (report_type == 2 && performance_report_type == 1)
                  "
                  >{{ $t("menu.number") }}</label
                >
                <div class="col-md-2">
                  <base-input id="report-number"
                    v-model="number"
                    v-if="
                      report_type == 1 ||
                        (report_type == 2 && performance_report_type == 1)
                    "
                  >
                  </base-input>
                </div>

                <label for="report-charging-group"
                  class="col-md-1 col-form-label form-control-label"
                  v-if="report_type == 1"
                >
                  {{ $t("report.charging_group") }}
                </label>
                <div class="col-md-2" v-if="report_type == 1">
                  <base-input id="report-charging-group" v-model="charging_group"> </base-input>
                </div>
              </div>

              <div class="form-group row">
                <span class="col-md-1 col-form-label form-control-label">{{
                  $t("report.date")
                }}</span>
                <div class="col-md-2">
                  <base-input :label="$t('report.start')">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="start_date"
                    >
                    </flat-picker>
                  </base-input>
                </div>
                <div class="col-md-2">
                  <base-input :label="$t('report.end')">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="end_date"
                    >
                    </flat-picker>
                  </base-input>
                </div>
              </div>

              <div class="form-group row">
                <div
                  class="col-md-1 col-form-label form-control-label"
                ></div>

                <base-button type="info" @click="handleSearch()">{{
                  $t("report.search")
                }}</base-button>
                <base-button
                  v-if="report_type == 1 && getCdr != null"
                  type="info"
                  @click="handleExport()"
                  >{{ $t("report.export") }}</base-button
                >
                <base-button
                  v-if="report_type == 2"
                  type="info"
                  @click="handleExportChart()"
                  >{{ $t("report.export") }}</base-button
                >

                <strong>
                  <div class="col-md-12">* {{ $t("report.date_warning") }}</div>
                </strong>
              </div>

              <br />
              <card v-if="report_type == 2">
                <template slot="header">
                  <!-- Title -->
                  <h5 class="h3 mb-0" v-if="performance_report_type == 1">
                    {{ $t("report.performance_by_number") }}
                  </h5>
                  <h5 class="h3 mb-0" v-if="performance_report_type == 2">
                    {{ $t("report.performance_by_group") }}
                  </h5>
                </template>

                <div class="row">
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.total_call')"
                      type="gradient-red"
                      :sub-title="dashboard.TotalCall"
                      icon="fa fa-phone-square"
                    >
                    </stats-card>
                  </div>

                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.answered')"
                      type="gradient-green"
                      :sub-title="dashboard.Answered"
                      icon="fa fa-phone-square"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.unanswered')"
                      type="gradient-orange"
                      :sub-title="dashboard.Unanswered"
                      icon="fa fa-phone-square"
                    >
                    </stats-card>
                  </div>

                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.call_voicemail')"
                      type="gradient-info"
                      :sub-title="dashboard.Voicemail"
                      icon="fa fa-phone-square"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.talk_time')"
                      type="gradient-red"
                      :sub-title="dashboard.TalkTime"
                      icon="ni ni-time-alarm"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.speed_of_answer')"
                      type="gradient-orange"
                      :sub-title="dashboard.SpeedOfAnswer"
                      icon="ni ni-time-alarm"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.avg_waiting_time')"
                      type="gradient-info"
                      :sub-title="dashboard.AvgWaitingTime"
                      icon="ni ni-time-alarm"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.avg_talk_time')"
                      type="gradient-red"
                      :sub-title="dashboard.AvgTalkTime"
                      icon="ni ni-time-alarm"
                    >
                    </stats-card>
                  </div>
                  <div class="col-xl-4 col-md-6">
                    <stats-card
                      :title="$t('report.longest_waiting_time')"
                      type="gradient-green"
                      :sub-title="dashboard.LongestWaitingTime"
                      icon="ni ni-time-alarm"
                    >
                    </stats-card>
                  </div>
                </div>

                <div class="chart" v-if="performance_report_type == 2">
                  <bar-chart
                    :chart-data="dashboard_number.ChartData"
                    :extra-options="extraOptionsByNumber"
                    :height="350"
                  />
                </div>
              </card>

              <card
                card
                v-if="performance_report_type == 1 && report_type == 2"
              >
                <template slot="header">
                  <!-- Title -->
                  <h5 class="h3 mb-0">{{ $t("report.call_volume") }}</h5>
                </template>
                <div class="chart">
                  <bar-chart
                    :height="350"
                    :chart-data="dashboard_group.ChartData"
                    :extra-options="extraOptions"
                  />
                </div>
              </card>
            </div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
              v-if="report_type == 1"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

            </div>
            <br />

            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              v-if="report_type == 1"
            >
              <el-table-column
                :label="$t('report.enterprise')"
                prop="BusinessGroupName"
                min-width="200"
              >
              </el-table-column>
              <el-table-column
                :label="$t('report.call_dates')"
                prop="CallDate"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                :label="$t('report.call_origination')"
                min-width="160"
              >
                <div slot-scope="{ row }" class="d-flex">
                  <div
                    v-if="
                      row.CallOrigination == '' || row.CallOrigination == null
                    "
                  >
                    {{ $t("report.no_number") }}
                  </div>
                  <div v-else>{{ row.CallOrigination }}</div>
                </div>
              </el-table-column>

              <el-table-column
                :label="$t('report.display_number')"
                min-width="160"
              >
                <div slot-scope="{ row }" class="d-flex">
                  <div
                    v-if="
                      row.DisplayNumber == '' ||
                        row.DisplayNumber == null ||
                        row.DisplayNumber == '66'
                    "
                  >
                    {{ $t("report.no_number") }}
                  </div>
                  <div v-else>{{ row.DisplayNumber }}</div>
                </div>
              </el-table-column>

              <el-table-column
                :label="$t('report.call_termination')"
                prop="CallTermination"
                min-width="160"
              ></el-table-column>
              <el-table-column :label="$t('report.status')" min-width="120">
                <template v-slot="{ row }">
                  <span class="status" v-if="row.Status == 1">{{
                    $t("report.status_answered")
                  }}</span>
                  <span class="status" v-else>{{
                    $t("report.status_no_answer")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('report.start_time')"
                prop="StartTime"
                min-width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('report.ringing')"
                prop="RingingDuration"
                min-width="170"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('report.answered_time')"
                prop="AnswerdTime"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('report.terminated_time')"
                prop="TerminatedTime"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                :label="$t('report.terminated_reason')"
                min-width="170"
                align="center"
              >
                <template v-slot="{ row }">
                  <a
                    href="#"
                    class="status"
                    @click="showQ850(row.TerminatedReason)"
                    >{{ row.TerminatedReason }}

                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </a>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('report.reason_change')"
                prop="ReasonChange"
                min-width="220"
              ></el-table-column>
              <el-table-column
                :label="$t('report.final_number')"
                prop="FinalNumber"
                min-width="160"
              ></el-table-column>
              <el-table-column
                :label="$t('report.duration')"
                prop="Duration"
                min-width="150"
              ></el-table-column>
              <el-table-column :label="$t('report.type')" min-width="120">
                <template v-slot="{ row }">
                  <span class="status" v-if="row.RecType == 1">{{
                    $t("report.inbound")
                  }}</span>
                  <span class="status" v-if="row.RecType == 2">{{
                    $t("report.outbound")
                  }}</span>
                  <span class="status" v-if="row.RecType == 3">{{
                    $t("report.internal")
                  }}</span>
                  <span class="status" v-if="row.RecType == 4">{{
                    $t("report.voicemail")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('report.charging_group')"
                prop="ChargingGroup"
                min-width="200"
              ></el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
            v-if="report_type == 1"
          >
            <div class="" v-if="total != 0">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              v-if="total != 0"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PagingReport/clientPaginationMixin";
import BarChart from "@/components/Charts/BarChart";
// import HorizentalBarChart from "@/components/Charts/HBarChart";
import swal from "sweetalert2";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    BarChart,
    // HorizentalBarChart,
    flatPicker,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  mounted() {
    const today = new Date();
    this.start_date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    this.end_date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    this.initReport();
    this.listCorporate();
  },
  watch: {

    // if number change allow number only
    number: function(val) {
      this.number = val.replace(/\D/g, "");
    },
  },
  computed: {
    ...mapGetters({
      corporate: "Corporate/getData",
      getCdr: "Cdr/getCdr",
      isWaiting: "Cdr/isWaiting",
      dashboardNumber: "Cdr/getDashboardNumber",
      dashboardGroup: "Cdr/getDashboardGroup",
      dashboardData: "Cdr/getDashboard",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      isCorporateSuperAdminMenu: "Auth/isCorporateSuperAdminMenu"
    }),

    tableData: function() {
      return this.getCdr != null ? this.getCdr : [];
    },

    number_of_call_text: function() {
      return this.$t("report.number_of_calls");
    },

    dashboard: function() {
      if (this.dashboardData != null) {
        return {
          TotalCall: this.dashboardData.TotalCall,
          Answered: this.dashboardData.Answered,
          Unanswered: this.dashboardData.Unanswered,
          Voicemail: this.dashboardData.Voicemail,
          TalkTime: this.dashboardData.TalkTime,
          IdleTime: this.dashboardData.IdleTime,
          SpeedOfAnswer: this.dashboardData.SpeedOfAnswer,
          AvgTalkTime: this.dashboardData.AvgTalkTime,
          AvgWaitingTime: this.dashboardData.AvgWaitingTime,
          LongestWaitingTime: this.dashboardData.LongestWaitingTime
        };
      } else {
        return {
          TotalCall: "0",
          Answered: "0",
          Unanswered: "0",
          Voicemail: "0",
          TalkTime: "0",
          IdleTime: "0",
          SpeedOfAnswer: "0",
          AvgTalkTime: "0",
          AvgWaitingTime: "0",
          LongestWaitingTime: "0"
        };
      }
    },

    dashboard_number: function() {
      if (this.dashboardData != null) {
        return {
          ChartData: {
            labels: [
              this.$t("report.outbound"),
              this.$t("report.inbound"),
              this.$t("report.internal"),
              this.$t("report.voicemail")
            ],
            datasets: [
              {
                label: "Call Volume",
                data: this.dashboardData.CallDistribution.Value,
                backgroundColor: ["#ff6384", "#36a2eb", "#43a047", "#ffca28"]
              }
            ]
          }
        };
      } else {
        return {
          ChartData: {
            labels: [
              this.$t("report.outbound"),
              this.$t("report.inbound"),
              this.$t("report.internal"),
              this.$t("report.voicemail")
            ],
            datasets: [
              {
                label: "Call Volume",
                data: [0, 0, 0, 0],
                backgroundColor: ["#ff6384", "#36a2eb", "#43a047", "#ffca28"]
              }
            ]
          }
        };
      }
    },
    dashboard_group: function() {
      if (this.dashboardData != null) {
        return {
          ChartData: {
            labels: this.dashboardData.CallVolume.Label,
            datasets: [
              {
                label: this.$t("report.outbound"),
                data: this.dashboardData.CallVolume.Outgoing,
                backgroundColor: "lightblue" // green
              },
              {
                label: this.$t("report.inbound"),
                data: this.dashboardData.CallVolume.Incoming,
                backgroundColor: "orange" // yellow
              },
              {
                label: this.$t("report.internal"),
                data: this.dashboardData.CallVolume.Internal,
                backgroundColor: "lime" // yellow
              },
              {
                label: this.$t("report.voicemail"),
                data: this.dashboardData.CallVolume.Voicemail,
                backgroundColor: "yellow" // yellow
              }
            ]
          }
        };
      } else {
        return {
          ChartData: {
            labels: [],
            datasets: [
              {
                label: "Outgoing (Calls)",
                data: [],
                backgroundColor: "lightblue" // green
              },
              {
                label: "Incomming (Calls)",
                data: [],
                backgroundColor: "orange" // yellow
              },
              {
                label: "Internal (Calls)",
                data: [],
                backgroundColor: "green" // yellow
              },
              {
                label: "Voicemail (Calls)",
                data: [],
                backgroundColor: "yellow" // yellow
              }
            ]
          }
        };
      }
    },
    tableColumns: function() {
      return [
        {
          prop: "CallDate",
          label: "Call Date",
          minWidth: 110,
          sortable: false
        },
        {
          prop: "CallOrigination",
          label: "Call Origination",
          minWidth: 150,
          sortable: false
        },
        {
          prop: "DisplayNumber",
          label: "Display Number",
          minWidth: 150,
          sortable: false
        },

        {
          prop: "CallTermination",
          label: "Call Termination",
          minWidth: 150,
          sortable: false
        },
        {
          prop: "Status",
          label: "Status",
          minWidth: 120,
          sortable: false
        },
        {
          prop: "StartTime",
          label: "Call Start Time",
          minWidth: 100,
          sortable: false
        },
        {
          prop: "RingingDuration",
          label: "Ringing Duration",
          minWidth: 150,
          sortable: false
        },
        {
          prop: "AnswerdTime",
          label: "Call Answered Time",
          minWidth: 100,
          sortable: false
        },
        {
          prop: "TerminatedTime",
          label: "Call Terimated Time",
          minWidth: 100,
          sortable: false
        },
        {
          prop: "TerminatedReason",
          label: "Call Terimated Reason",
          minWidth: 200,
          sortable: false
        },
        {
          prop: "ReasonChange",
          label: "Reason-Change",
          minWidth: 150,
          sortable: false
        },
        {
          prop: "FinalNumber",
          label: "Final Number",
          minWidth: 150,
          sortable: false
        },
        {
          prop: "Duration",
          label: "Duration",
          minWidth: 120,
          sortable: false
        },
        {
          prop: "RecType",
          label: "Call Type",
          minWidth: 120,
          sortable: false
        }
      ];
    }
  },
  data() {
    return {
      EnterpriseID: "",
      report_type: 1,
      call_type: 0,
      call_status: 0,
      performance_report_type: 1,
      start_date: "",
      end_date: "",
      number: "",
      charging_group: "",
      isShowWating: false,
      extraOptionsByNumber: {
        responsive: true,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t("report.number_of_calls")
              }
            }
          ]
        }
      },
      extraOptions: {
        tooltips: {
          mode: "index",
          intersect: false
        },
        responsive: true,
        scales: {
          xAxes: [
            {
              stacked: false
            }
          ],
          yAxes: [
            {
              stacked: false,
              scaleLabel: {
                display: true,
                labelString: this.$t("report.number_of_calls")
              }
            }
          ]
        }
      },

      RecordChart: {},
      propsToSearch: ["name", "email", "age"],
      selectedRows: [],
      stateTimerCount: 0,
      state: 0 // 1=processing // 2=succes
    };
  },
  methods: {
    ...mapActions({
      initReport: "Cdr/initReport",
      listCdr: "Cdr/listCdr",
      listDashboard: "Cdr/listDashboard",
      //   listDashboardNumber: "Cdr/listDashboardNumber",
      //   listDashboardGroup: "Cdr/listDashboardGroup",
      listCorporate: "Corporate/listData"
    }),
    handleExport() {
      let dataExport = this.getCdr.map(it => {
        return {
          ID: it.ID,
          BusinessGroupName: it.BusinessGroupName,
          CallDate: it.CallDate,
          CallOrigination:
            it.CallOrigination == "" || it.CallOrigination == null
              ? this.$t("report.no_number")
              : it.CallOrigination,
          DisplayNumber:
            it.DisplayNumber == "" ||
            it.DisplayNumber == "66" ||
            it.DisplayNumber == null
              ? this.$t("report.no_number")
              : it.DisplayNumber,
          CallTermination: it.CallTermination,
          Status: it.Status,
          StartTime: it.StartTime,
          RingingDuration: it.RingingDuration,
          AnswerdTime: it.AnswerdTime,
          TerminatedTime: it.TerminatedTime,
          TerminatedReason: it.TerminatedReason,
          ReasonChange: it.ReasonChange,
          FinalNumber: it.FinalNumber,
          Duration: it.Duration,
          RecType: it.RecType,
          ChargingGroup: it.ChargingGroup
        };
      });

      let array = [Object.keys(this.getCdr[0])].concat(dataExport);

      let csvContent = array
        .map(it => {
          return Object.values(it).toString();
        })
        .join("\n");
      const universalBOM = "\uFEFF";
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);

      link.click();
    },
    handleExportChart() {
      //   let array = [
      //     {
      //       TotalCall: "TotalCall",
      //       Answered: "Answered",
      //       Unanswered: "Unanswered",
      //       Voicemail: "Voicemail",
      //       AvgTalkTime: "AvgTalkTime",
      //       AvgWaitingTime: "AvgWaitingTime",
      //       IdleTime: "IdleTime",
      //       LongestWaitingTime: "LongestWaitingTime",
      //       SpeedOfAnswer: "SpeedOfAnswer",
      //       TalkTime: "TalkTime"
      //     },
      //     {
      //       TotalCall: this.dashboard.TotalCall,
      //       Answered: this.dashboard.Answered,
      //       Unanswered: this.dashboard.Unanswered,
      //       Voicemail: this.dashboard.Voicemail,
      //       AvgTalkTime: this.dashboard.AvgTalkTime,
      //       AvgWaitingTime: this.dashboard.AvgWaitingTime,
      //       IdleTime: this.dashboard.IdleTime,
      //       LongestWaitingTime: this.dashboard.LongestWaitingTime,
      //       SpeedOfAnswer: this.dashboard.SpeedOfAnswer,
      //       TalkTime: this.dashboard.TalkTime
      //     }
      //   ];

      let array_en = [
        {
          TotalCall: "ALL TRANSACTION LOGS",
          Answered: "ALL VOICE CALLS (OUTGOING AND INCOMING)",
          Unanswered:
            '"ALL MISSED INCOMING CALLS, MISSED OUTGOING CALLS AND MISSED CALLS TO HUNTING GROUP"',
          Voicemail: "VOICEMAIL (CALLS)",
          AvgTalkTime: "AVG TALK TIME (SECOND)",
          AvgWaitingTime: "AVERAGE STAFF’S CALL WAITING TIME (SECOND)",
          LongestWaitingTime:
            "LONGEST CALL WAITING TIME (INCLUDING OUTGOING AND INCOMING CALLS)",
          SpeedOfAnswer: "SPEED OF ANSWER (SECOND)",
          TalkTime:
            "ALL VOICE CALL DURATION INCLUDING DTAC ONECALL CONNECTION DURATION"
        },
        {
          TotalCall: this.dashboard.TotalCall,
          Answered: this.dashboard.Answered,
          Unanswered: this.dashboard.Unanswered,
          Voicemail: this.dashboard.Voicemail,
          AvgTalkTime: this.dashboard.AvgTalkTime,
          AvgWaitingTime: this.dashboard.AvgWaitingTime,
          LongestWaitingTime: this.dashboard.LongestWaitingTime,
          SpeedOfAnswer: this.dashboard.SpeedOfAnswer,
          TalkTime: this.dashboard.TalkTime
        }
      ];

      let array_th = [
        {
          TotalCall: "จำนวน TRANSACTION LOG ทั้งหมด",
          Answered: "จำนวนสายสนทนา (โทรออกและรับสาย) ทั้งหมด",
          Unanswered:
            '"จำนวนสายที่ไม่ได้รับทั้งหมดของสายเรียกเข้า, สายโทรออก และสายถึง CALL HUNTING GROUP"',
          Voicemail: "ข้อความเสียง (สาย)",
          AvgTalkTime: "ค่าเฉลี่ยระยะเวลาสนทนาทั้งหมด (วินาที)",
          AvgWaitingTime: "ระยะเวลาเฉลี่ยที่เจ้าหน้าที่รอสาย (วินาที)",
          LongestWaitingTime:
            "ระยะเวลารอสายที่นานที่สุด (รวมสายโทรออกและรับสาย)",
          SpeedOfAnswer: "ความเร็วในการรับสาย (วินาที)",
          TalkTime: "ระยะเวลาสนทนารวมเชื่อมต่อ DTAC ONECALL ทั้งหมด"
        },
        {
          TotalCall: this.dashboard.TotalCall,
          Answered: this.dashboard.Answered,
          Unanswered: this.dashboard.Unanswered,
          Voicemail: this.dashboard.Voicemail,
          AvgTalkTime: this.dashboard.AvgTalkTime,
          AvgWaitingTime: this.dashboard.AvgWaitingTime,
          LongestWaitingTime: this.dashboard.LongestWaitingTime,
          SpeedOfAnswer: this.dashboard.SpeedOfAnswer,
          TalkTime: this.dashboard.TalkTime
        }
      ];

      let array = array_en;
      if (this.$i18n.locale == "th") {
        array = array_th;
      }

      let csvContent = array
        .map(it => {
          return Object.values(it).toString();
        })
        .join("\n");

      let array_number = "";
      this.dashboard_number.ChartData.labels.forEach((item, index) => {
        // let itemtxt = this.$t(item);
        array_number += index == 0 ? item : "," + item;
      });

      array_number += "\n";
      this.dashboard_number.ChartData.datasets[0].data.forEach(
        (item, index) => {
          array_number += index == 0 ? item : "," + item;
        }
      );

      // Add Chart 2
      let array_group = this.$t("report.call_type");
      this.dashboard_group.ChartData.labels.forEach((item, index) => {
        array_group += "," + item;
      });
      array_group += "\n";

      // data serries
      this.dashboard_group.ChartData.datasets.forEach(item => {
        array_group += item.label;
        item.data.forEach(i => {
          array_group += "," + i;
        });
        array_group += "\n";
      });

      csvContent += "\n\n" + array_number;
      csvContent += "\n\n" + array_group;

      const universalBOM = "\uFEFF";
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      link.setAttribute("download", "export.csv");
      document.body.appendChild(link);

      link.click();
    },
    handleSearch(index, row) {
      const date1 = new Date(this.start_date);
      const date2 = new Date(this.end_date);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // console.log(diffTime + " milliseconds");
      // console.log(diffDays + " days");

      if (diffDays > 90) {
        swal.fire({
          title: this.$t("errors.invalid_date_range_over_90"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info btn-fill"
        });
        return;
      }

      if (this.report_type == 1) {
        // Cdr
        let params = {
          enterprise_id: this.EnterpriseID == "" ? 0 : this.EnterpriseID,
          call_type: this.call_type,
          call_status: this.call_status,
          start_date: this.start_date,
          end_date: this.end_date,
          number: this.number,
          charging_group: this.charging_group
        };
        this.listCdr(params);
      } else {
        let params = {
          enterprise_id: this.EnterpriseID == "" ? 0 : this.EnterpriseID,
          call_status: this.call_status,
          start_date: this.start_date,
          end_date: this.end_date,
          number:
            this.report_type == 2 && this.performance_report_type == 1
              ? this.number
              : ""
        };

        this.listDashboard(params);
        console.log("start search");
        // swal.fire({
        // 	title: this.$t("processing"),
        // 	allowEscapeKey: false,
        // 	allowOutsideClick: false,
        // 		// timer: 5000,
        // 	onOpen: () => {
        // 		swal.showLoading();
        // 	}
        // })
        setTimeout(() => {
          console.log("setup pooling");
          this.handleSearchPooling();
        }, 1000);
      }
    },
    handleSearchPooling() {
      if (this.isWaiting == false) {
        console.log("pooling end");
        return;
      }

      let params = {
        enterprise_id: this.EnterpriseID == "" ? 0 : this.EnterpriseID,
        call_status: this.call_status,
        start_date: this.start_date,
        end_date: this.end_date,
        number:
          this.report_type == 2 && this.performance_report_type == 1
            ? this.number
            : ""
      };

      this.listDashboard(params);
      console.log("pooling request");
      setTimeout(() => {
        console.log("pooling continue");
        this.handleSearchPooling();
      }, 2000);
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    showQ850(code) {
      const q850 = {
        0: "Valid cause code not yet received",
        1: "Unallocated (unassigned) number",
        2: "No route to specified transit network (WAN)",
        3: "No route to destination",
        4: "send special information tone",
        5: "misdialled trunk prefix.",
        6: "Channel unacceptable",
        7: "Call awarded and being delivered in an established channel",
        8: "Prefix 0 dialed but not allowed",
        9: "Prefix 1 dialed but not allowed",
        10: "Prefix 1 dialed but not required",
        11: "More digits received than allowed: call is proceeding",
        16: "Normal call clearing",
        17: "User busy",
        18: "No user responding",
        20: "Subscriber absent",
        19: "no answer from user",
        21: "Call rejected",
        22: "Number changed",
        23: "Reverse charging rejected",
        24: "Call suspended",
        25: "Call resumed",
        26: "Non-selected user clearing",
        27: "Destination out of order",
        28: "Invalid number format (incomplete number)",
        29: "Facility rejected",
        30: "Response to STATUS ENQUIRY",
        31: "Normal: unspecified",
        33: "Circuit out of order",
        34: "No circuit/channel available",
        35: "Destination unattainable",
        37: "Degraded service",
        38: "Network (WAN) out of order",
        39: "Transit delay range cannot be achieved",
        40: "Throughput range cannot be achieved",
        41: "Temporary failure",
        42: "Switching equipment congestion",
        43: "Access information discarded",
        44: "Requested circuit channel not available",
        45: "Pre-empted",
        46: "Precedence call blocked",
        47: "Resource unavailable – unspecified",
        49: "Quality of service unavailable",
        50: "Requested facility not subscribed",
        51: "Reverse charging not allowed",
        52: "Outgoing calls barred",
        53: "Outgoing calls barred within CUG",
        54: "Incoming calls barred",
        55: "Incoming calls barred within CUG",
        56: "Call waiting not subscribed",
        57: "Bearer capability not authorized",
        58: "Bearer capability not presently available",
        63: "Service or option not available: unspecified",
        65: "Bearer service not implemented",
        66: "Channel type not implemented",
        67: "Transit network selection not implemented",
        68: "Message not implemented",
        69: "Requested facility not implemented",
        70: "Only restricted digital information bearer capability is available",
        79: "Service or option not implemented: unspecified",
        81: "Invalid call reference value",
        82: "Identified channel does not exist",
        83: "A suspended call exists: but this call identity does not",
        84: "Call identity in use",
        85: "No call suspended",
        86: "Call having the requested call identity has been cleared",
        87: "Called user not member of CUG",
        88: "Incompatible destination",
        89: "Non-existent abbreviated address entry",
        90: "Destination address missing: and direct call not subscribed",
        91: "Invalid transit network selection (national use)",
        92: "Invalid facility parameter",
        93: "Mandatory information element is missing",
        95: "Invalid message: unspecified",
        96: "Mandatory information element is missing",
        97: "Message type non-existent or not implemented",
        98: "Message not compatible with call state or message type non-existent or not implemented",
        99: "information element nonexistent or not implemented",
        100: "Invalid information element contents",
        101: "Message not compatible with call state",
        102: "Recovery on timer expiry",
        103: "parameter non-existent or not implemented – passed on",
        111: "Protocol error unspecified",
        127: "Internetworking: unspecified"
      };

      if (q850[code] != "") {
        swal.fire({
          title: code + " - " + q850[code],
          icon: "info",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$t("close")
        });
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
.no-border-card .card-footer {
  border-top: 0;
}
</style>
